module.exports = __webpack_public_path__ + "static/media/contest2025_fifth_place_profileImage.3423fc30.jpeg";